import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Category } from '@/interfaces/catalog/Category'
import { flattenCategories } from '@/lib/catalog/categoryUtils'

import { CategoryFormValues } from './schema'

interface CategoryFormProps {
  categories?: Category[]
  editingCategoryId?: string
}

export const CategoryForm = ({
  categories = [],
  editingCategoryId,
}: CategoryFormProps) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'catalog.categories',
  })
  const { control } = useFormContext<CategoryFormValues>()

  const parentOptions = flattenCategories(categories, editingCategoryId)

  return (
    <div className="space-y-4">
      <FormField
        control={control}
        name="name"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('form.name.label')}</FormLabel>
            <FormControl>
              <Input placeholder={t('form.name.placeholder')} {...field} autoComplete='off' />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={control}
        name="parentId"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('form.parent.label')}</FormLabel>
            <Select
              {...field}
              onValueChange={(value) => {
                field.onChange(value)
              }}
            >
              <FormControl className="w-full">
                <SelectTrigger>
                  <SelectValue placeholder={t('form.parent.placeholder')} />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value={null!}>{t('form.parent.none')}</SelectItem>
                {parentOptions.map((option) => (
                  <SelectItem key={option.id} value={option.id}>
                    {option.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )}
      />

      {/* <FormField
        control={control}
        name="externalId"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('form.externalId.label')}</FormLabel>
            <FormControl>
              <Input
                placeholder={t('form.externalId.placeholder')}
                {...field}
                value={field.value ?? ''}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      /> */}
    </div>
  )
}
